import { useState } from 'react'
import { useSelector } from 'react-redux'
import { MovementsDesktop } from 'Ui/Components/movements/MovementsDesktop'

/*****************************************************************
 * TOOTH MOVEMENTS IN BOTTOM PANEL
 * ***************************************************************/

 const
    section = [
        'CURRENT',
        'TOTAL'
    ],
    teeth = {
        tpUpper: [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28],
        tpLower: [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38]
    },
    spe = [
        'torque',
        'lingualVestibular',
        'extrusionIntrusion',
        'tip',
        'distalMesial',
        'rotation'
    ]

/**
 * Component Movements specification
 * @returns {JSX} - return desktop components
 */
export const Movements = props => {

    const
        [jaw, setJaw] = useState( (props.mvt.includes('upper')? 'tpUpper': 'tpLower' ) ),
        { AnimationReducer } = useSelector((state) => state),
        metas = AnimationReducer.metas,
        keyframe = AnimationReducer.keyframe.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        }),
        getNumeric = ( sect ,special ,tooth, type ) => {
            let
                nb,
                sector = (sect !== 'TOTAL') ? 'step_'+keyframe : 'totalAmount',
                container = metas.treatmentPlanning[jaw][sector]

            if ( container )
                if(container['toothID_'+tooth]) {
                    const numericValue = Number.parseFloat(container['toothID_'+tooth][type][special]);
                    if (numericValue < -99999 || numericValue > 99999) {
                        return false;
                    }
                    nb = numericValue.toFixed(1);
                }

            return (nb !== '0.0' && nb !== '-0.0') ? nb : false
        },
        getTpJaw = type => {
            return {
                name: 'tp' + type.charAt(0).toUpperCase() + type.slice(1),
                TRANS: ( type === 'upper' )? 'SPE_MAXI': 'SPE_MAND'
            }
        },
        { mvt } = props,
        childProps = {
            section,
            spe,
            jaw,
            setJaw,
            getNumeric,
            getTpJaw,
            mvt,
            teeth: teeth
        }

    return <MovementsDesktop {...childProps} />;

}
